module.exports = __webpack_public_path__ + "static/media/damandeep.63badccb.jpg";